import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=90950fba&scoped=true"
import script from "./category-list.vue?vue&type=script&lang=js"
export * from "./category-list.vue?vue&type=script&lang=js"
import style0 from "./category-list.vue?vue&type=style&index=0&id=90950fba&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90950fba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90950fba')) {
      api.createRecord('90950fba', component.options)
    } else {
      api.reload('90950fba', component.options)
    }
    module.hot.accept("./category-list.vue?vue&type=template&id=90950fba&scoped=true", function () {
      api.rerender('90950fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/product-management/category-management/category-list.vue"
export default component.exports